<template>
  <div>
    <base-title-bar-scroll-page ref="container" title="缴费记录查询" :showTitleBar="!isApp">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="payment-records-page">
          <div v-if="loading" class="payment-records__loading">
            <van-loading color="#4A90E2" size="24">加载中...</van-loading>
          </div>

          <div v-else-if="paymentRecords.length === 0" class="payment-records__empty">
            <van-icon name="balance-pay" size="60" color="#d4d8de" />
            <p class="empty-text">暂无缴费记录</p>
            <p class="empty-tip">您还没有缴费记录</p>
          </div>

          <div v-else class="payment-records__list">
            <div
              class="payment-record-item"
              v-for="(record, index) in paymentRecords"
              :key="index"
            >
              <div class="payment-record-item__header">
                <div class="payment-record-item__hospital">{{ record.hospital }}</div>
                <div class="payment-record-item__amount">¥{{ record.amount }}</div>
              </div>
              <div class="payment-record-item__content">
                <div class="payment-record-item__row">
                  <span class="payment-record-item__label">下单时间:</span>
                  <span class="payment-record-item__value">{{ formatPaymentDate(record.orderDate) }}</span>
                </div>
                <div class="payment-record-item__row">
                  <span class="payment-record-item__label">开单医生:</span>
                  <span class="payment-record-item__value">{{ record.doctor }}</span>
                </div>
                <div class="payment-record-item__row">
                  <span class="payment-record-item__label">所属科室:</span>
                  <span class="payment-record-item__value">{{ record.department }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </base-title-bar-scroll-page>
  </div>
</template>

<script>
import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'

export default {
  name: 'ShunyiPaymentRecords',
  components: { BaseTitleBarScrollPage },
  data () {
    return {
      isApp: false,
      loading: false,
      refreshing: false,
      paymentRecords: [
        {
          hospital: '暨南大学附属顺德医院',
          orderDate: '2026-07-02 09:38:22',
          amount: '980.00',
          doctor: '钟德顺',
          department: '康复医学科'
        }
      ]
    }
  },
  mounted () {
    const query = this.$route.query
    if (query.from === 'wxapp') {
      this.isApp = true
    }
    this.loadPaymentRecords()
  },
  methods: {
    hideLoading () {
      this.$refs.container.stopLoading()
    },
    async loadPaymentRecords () {
      try {
        this.loading = true
        const userId = this.$route.query.userId || sessionStorage.getItem('shunyi_user_id') || this.$store.state.user.profile.userId
        console.log('加载缴费记录, userId:', userId)

        // TODO: 调用实际API
        // const data = await PaymentDao.getPaymentRecords(userId)
        // this.paymentRecords = data || []

        // 模拟数据 - 使用data中定义的初始数据
        await new Promise(resolve => setTimeout(resolve, 500))
        // 保持使用data中定义的初始数据，不重新赋值
      } catch (error) {
        console.error('加载缴费记录失败:', error)
        this.$toast('加载缴费记录失败')
      } finally {
        this.loading = false
        this.hideLoading()
      }
    },
    async onRefresh () {
      await this.loadPaymentRecords()
      this.refreshing = false
      this.$toast.success('刷新成功')
    },
    formatPaymentDate (dateStr) {
      if (!dateStr) return ''
      try {
        const date = new Date(dateStr)
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        return `${year}-${month}-${day}`
      } catch (error) {
        return dateStr
      }
    }
  }
}
</script>

<style scoped>
.payment-records-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #E8F5FD 0%, #F5F7FA 100%);
  padding: 16px;
}

.payment-records__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
}

.payment-records__empty {
  text-align: center;
  padding: 80px 20px;
  color: #999999;
}

.empty-text {
  font-size: 16px;
  color: #646566;
  margin: 16px 0 8px;
}

.empty-tip {
  font-size: 13px;
  color: #969799;
  margin: 0;
}

.payment-records__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.payment-record-item {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.payment-record-item__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #F0F0F0;
}

.payment-record-item__hospital {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

.payment-record-item__amount {
  font-size: 20px;
  font-weight: 600;
  color: #FF6B35;
}

.payment-record-item__content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.payment-record-item__row {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.payment-record-item__label {
  color: #999999;
  margin-right: 8px;
  min-width: 72px;
}

.payment-record-item__value {
  color: #333333;
  font-weight: 500;
}
</style>
